import { createFileRoute } from '@tanstack/react-router';

/**
 * OAuth 콜백 성공 라우트 (/auth/callback-success)
 *
 * 백엔드가 OAuth 콜백 처리 후 이 페이지로 리다이렉트합니다.
 * 컴포넌트는 callback-success.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/auth/callback-success')({});
